// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Buttons_buttons_15_zv"};